<template>
    <div class="ma-2">
        <!-- delete dialog -->
        <v-delete-dialog
			v-model="deleteDialog"
			:module="'covenant/delete'"
			:parameters="{ id: itemId ? itemId : null }"
			@on-delete="fetchAll()"
        >
			{{ $T('Covenant.delete-message') }}
		</v-delete-dialog>

        <!-- dialog add covenant -->
        <v-dialog
			v-model="dialog"
			max-width="500px"
			transition="dialog-transition"
        >
			<v-card>
				<v-card-title primary-title>
                    {{ $T('Covenant.adding-covenant') }}
					<v-spacer></v-spacer>
					<v-btn
						@click="dialog = false"
						icon>
						<v-icon color="alert-color">mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-row dense>
						<v-col cols="6">
							<v-autocomplete
								v-model="recipient"
                                :items="employees"
                                item-text="name"
                                item-value="id"
								outlined
								dense
								:label="$t('inputs.recipient')"
								hide-details 
                            />
						</v-col>
                        <v-col cols="6">
                            <v-autocomplete
								v-model="itemCovenant"
                                :items="[]"
                                item-text="name"
                                item-value="id"
								outlined
								dense
								:label="$t('inputs.covenant')"
								hide-details 
                            />
                        </v-col>
                        <v-col cols="6">
                            <bee-date-input
                                v-model="deliveryDate"
                                :label="$T('inputs.date')"
                                hide-details
                                dense
                                prepend-icon="$calendar"
                                user-menu-picker
                            ></bee-date-input>
                        </v-col>
                        <v-col cols="6">
                            <bee-date-input
                                v-model="restoreDate"
                                :label="$T('inputs.date')"
                                hide-details
                                dense
                                prepend-icon="$calendar"
                                user-menu-picker
                            ></bee-date-input>
                        </v-col>
                        <v-col cols="12">
                            <v-textarea 
                                v-model="details"
                                outlined
								dense
								:label="$t('inputs.technical-specifications')"
								hide-details 
                            ></v-textarea>
                        </v-col>

                        <v-col cols="12">
                            <v-text-field 
                                v-model="notes"
                                outlined
								dense
								:label="$t('inputs.notes')"
								hide-details 
                            />
                        </v-col>
					</v-row>
				</v-card-text>
				<v-card-actions class="align-center">
					<v-spacer></v-spacer>
					<v-btn
						color="secondary"
						:disabled="loadingAdding || !recipient || !itemCovenant || !deliveryDate || !restoreDate || !details || !notes"
						:loading="loadingAdding"
						@click="createOrEdit">
						{{ $T('default-buttons.save') }}
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
        <v-spacer />
        <v-btn @click="dialog = true" class="mb-2" color="success" small>
            <v-icon small class="me-1"> $add </v-icon>
            {{ $t('add') }}
        </v-btn>
        <bee-handy-table 
            :items="items"
            :headers="headers"
            dense
            zebra
            hide-default-footer
            :items-per-page="-1"
        >
            <template v-slot:item.actions="{ item }">
                <div class="d-flex">
                    <v-btn
                    	icon
                    	small
                    	color="edit-color"
                        @click="itemId = item.id; dialog = true"
                    >
                        <v-icon>$edit</v-icon>
                    </v-btn>
             
                    <v-btn 
                        @click="
                            itemId = item.id
                            deleteDialog = true
                        " 
                        icon 
                        small 
                        color="alert"
                    >
                        <v-icon>$delete</v-icon>
                    </v-btn>
                </div>
            </template>
        </bee-handy-table>
    </div>
</template>
<script>
import moment from 'moment';
import { mapState } from 'vuex';
export default {
    watch: {
        dialog(val) {
            if(val && this.itemId) {
                // this.recipient = 
                // this.itemCovenant = 
                // this.details =
                // this.deliveryDate =
                // this.restoreDate =
                // this.notes =
            } else {
                this.recipient = null
                this.itemCovenant = null
                this.details = null
                this.deliveryDate = null
                this.restoreDate = null
                this.notes = null
                this.itemId = null
            }
        }
    },
    data () {
        return {
            loadingAdding: false,
            items: [],
            headers: [
                {
                    text: 'الرقم',
                    name: '',
                    value: ''
                },
                {
                    text: 'العهد',
                    name: '',
                    value: ''
                },
                {
                    text: 'مواصفات فنية',
                    name: '',
                    value: ''
                },
                {
                    text: 'تاريخ التسليم',
                    name: '',
                    value: ''
                },
                {
                    text: 'تاريخ الاستعادة',
                    name: '',
                    value: ''
                },
                {
                    text: 'ملاحظات',
                    name: '',
                    value: ''
                },
                {
                    text: '',
                    name: 'actions',
                    value: 'actions'
                }
            ],
            dialog: false,
            recipient: null,
            itemCovenant: null,
            details: null,
            deliveryDate: moment().format('YYYY-MM-DD'),
            restoreDate: null,
            notes: null,
            itemId: null,
            deleteDialog: false
        }
    },

    computed: {
        ...mapState({
            employees: (state) => state.employee.employees
        })
    },

    methods: {
        moment,
        fetchAll() {},
        createOrEdit() {

        }
    },

    created () {
        Promise.all([
            // items from emerald
            this.$store.dispatch('')
        ]).then(() => {
            this.fetchAll()
        })
       
    }
}
</script>
